'use client';

import { Box, Typography } from '@mui/material';
import styled from '@emotion/styled';
import { borderRadius, color, spacing, breakpoints } from '@/theme/tokens';
import { useTranslations } from 'next-intl';
import AuthorizedBrokers from '../authorizedBrokers/AuthorizedBrokers';
import { AuthorizedBrokersColorsPalette } from '../authorizedBrokers/types';
import { countryGroups } from '../authorizedBrokers/countryGroups';
import { BrokerLocation } from '@/components/contacts/ContactSection';
import { useIsGhana } from '@/components/hooks/useIsGhana';

interface BrokersSectionProps {
    brokers: BrokerLocation[];
}

const SectionContainer = styled(Box)`
    background-color: ${color.white[0]};
    padding: ${spacing[16]};
    border-radius: ${borderRadius[8]};

    @media (min-width: ${breakpoints.sm}) {
        padding: ${spacing[24]};
    }

    @media (min-width: ${breakpoints.md}) {
        padding: ${spacing[32]};
    }
`;

// Different colors for the authorized brokers section on homepage and contacts page
const colorsPalette: AuthorizedBrokersColorsPalette = {
    accordionTextColor: color.gray[80],
    accordionExpandedTextColor: color.gray[80],

    accordionBackgroundColor: color.gray[5],
    accordionExpandedBackgroundColor: color.gray[5],

    iconColor: color.gray[70],
    iconExpandedColor: color.gray[70],
};

export default function BrokersSection({ brokers }: BrokersSectionProps) {
    const isGhana = useIsGhana();
    const t = useTranslations('ContactsPage');
    return (
        <SectionContainer>
            <Typography variant="heading2bold" component="h2" color={color.gray[80]}>
                {t('brokerContacts')}
            </Typography>
            <Box sx={{ marginTop: { xs: spacing[16], sm: spacing[24], md: spacing[32] } }}>
                <AuthorizedBrokers
                    brokers={brokers}
                    countryGroups={countryGroups}
                    colorsPalette={colorsPalette}
                    twoColumnsFromMd
                    isGhana={isGhana}
                />
            </Box>
        </SectionContainer>
    );
}
